import * as THREE from 'three';
import { Config } from '../../core/Config';

export class Terrain {
  private mesh: THREE.Mesh;
  private geometry: THREE.PlaneGeometry;
  private material: THREE.MeshStandardMaterial;
  
  constructor(scene: THREE.Scene) {
    // Create a plane geometry
    this.geometry = new THREE.PlaneGeometry(
      Config.TERRAIN_SIZE,
      Config.TERRAIN_SIZE,
      Config.TERRAIN_RESOLUTION,
      Config.TERRAIN_RESOLUTION
    );
    
    // Rotate to be horizontal (XZ plane)
    this.geometry.rotateX(-Math.PI / 2);
    
    // Create a material with a simple green color
    this.material = new THREE.MeshStandardMaterial({
      color: 0x3a9d23, // Green color
      roughness: 0.8,
      metalness: 0.1,
      flatShading: true,
    });
    
    // Create the mesh and add to scene
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.receiveShadow = true;
    scene.add(this.mesh);
    
    console.log('Terrain initialized with solid color');
  }
  
  public update(deltaTime: number): void {
    // No updates needed for static terrain
  }
  
  public getMesh(): THREE.Mesh {
    return this.mesh;
  }
}
